import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { C as CastEducation } from "../../../../chunks/CastEducation.js";
import { A as AirplaneClock } from "../../../../chunks/AirplaneClock.js";
import { C as ClipboardEdit } from "../../../../chunks/ClipboardEdit.js";
import { C as CheckDecagram } from "../../../../chunks/CheckDecagram.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
let programs = true;
let pricingPackage = false;
let professionalProgram = false;
let background_center = false;
let hero_image = "/clouds_blue_sky_hero.webp";
let h1 = "Instrument Rating";
let hero_paragraph_content = "Instrument flight training deepens your understanding of subjects covered in private pilot training and incorporates specific knowledge related to flying in instrument meteorological conditions. Instrument-rated pilots can file IFR flight plans, allowing them to fly through clouds and navigate challenging airspace in a safer way and with greater ease.";
let center_img_seperating_section = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let roadmap_stages = [
    [
      {
        text: "Time Building",
        icon: AirplaneClock
      },
      {
        text: "Instrument Training",
        icon: CastEducation
      },
      {
        text: "Instrument Checkride",
        icon: ClipboardEdit
      },
      {
        text: "Instrument Add-on Acheived",
        icon: CheckDecagram
      }
    ]
  ];
  let second_center_img_seperating_section = {
    src: "/thumbs_up.webp",
    alt: "Thumbs up while taxiing an airplane"
  };
  let prerequisites = {
    eligibility: [
      "Hold at least a current private pilot certificate",
      "Be able to read, speak, write, and understand the English language proficiently",
      "Receive and log ground training from an authorized instructor or complete a home-study course on the aeronautical knowledge areas that apply to the instrument rating sought",
      "Have an instructor certify that you are prepared for the required knowledge test",
      "Receive and log training on the areas of operation",
      "Have an instructor certify that you are prepared for the required practical test",
      "Pass the knowledge test on aeronautical knowledge",
      "Pass the practical test"
    ],
    proficiency: [
      "Preflight preparation",
      "Preflight procedures",
      "Air traffic control clearances and procedures",
      "Flight by reference to instruments",
      "Navigation systems",
      "Instrument approach procedures",
      "Emergency operations",
      "Post-flight procedures"
    ],
    experience: [
      "50 hours of cross-country as pilot in command, 10 hours in an airplane",
      "40 hours of instrument time of which 15 hours must have been dual received from an instructor who holds an instrument-airplane rating and the instrument time includes:",
      "(a) 3 hours of instrument flight training from an instructor in an airplane that is appropriate to the instrument-airplane rating within 2 calendar months before the date of the practical test",
      "(b) Instrument flight training on cross country flight procedures, including one cross country flight in an airplane with an instructor, that is performed under instrument flight rules, when a flight plan has been filed with an air traffic control facility, and that involves:",
      "(i) A flight of 250 nautical miles along airways or by directed routing from an air traffic control facility",
      "(ii) An instrument approach at each airport",
      "(iii) Three different kinds of approaches with the use of navigation systems"
    ]
  };
  let faqs = [
    {
      question: "What is IFR in aviation",
      answer: "IFR is a set of regulations and procedures that govern flying in conditions where visual flight references are not sufficient. This involves flying with reference to instruments and navigation aids rather than relying solely on visual cues. IFR allows pilots to fly in low visibility, clouds, and adverse weather conditions, ensuring safety and accurate navigation.",
      opened: false
    },
    {
      question: "Can I work while taking the course?",
      answer: "Many students work part-time while pursuing their PPL. However, it's essential to balance your time effectively to ensure successful completion of the course.",
      opened: false
    },
    {
      question: "Can I choose when to schedule my flight lessons?",
      answer: "Yes, flight lessons are often flexible and can be scheduled to fit your availability, as long as your flight instructor is available.",
      opened: false
    }
  ];
  return `${$$result.head += `<!-- HEAD_svelte-18gqcp6_START -->${$$result.title = `<title>Instrument Rating | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation airplane instrument training"><!-- HEAD_svelte-18gqcp6_END -->`, ""} ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      faqs,
      programs,
      pricingPackage,
      professionalProgram,
      hero_image,
      background_center,
      h1,
      hero_paragraph_content,
      roadmap_stages,
      center_img_seperating_section,
      second_center_img_seperating_section,
      prerequisites
    },
    {},
    {
      three: () => {
        return `<div slot="three">${validate_component(CopyCard, "CopyCard").$$render($$result, { src: "/instrument_checkride.webp" }, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1nlm994">A check-ride is an essential part of the pilot certification process
        that includes both a flight test and an oral exam. During a check-ride,
        a designated pilot examiner (DPE) assesses the pilot&#39;s ability to
        operate an aircraft safely and proficiently. The examination covers
        various aspects, including flight maneuvers, navigation, emergency
        procedures, communication skills, and a thorough understanding of
        aviation regulations.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-5aur3t">Checkride Information</div>`;
          }
        })}</div>`;
      },
      two: () => {
        return `<div slot="two">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-gf3u28">In order to obtain your instrument rating, you must be able to read,
        speak, write, and understand the English language proficiently and be at
        least 17 years of age. You will also need a medical certificate (third
        class or better) from an FAA approved aviation medical examiner (AME),
        proof of U.S citizenship or TSA approval, as well as a private pilot
        certificate.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-gjaehl">What Do You Need to Start?</div>`;
          }
        })}</div>`;
      },
      one: () => {
        return `<div slot="one">${validate_component(CopyCard, "CopyCard").$$render($$result, { src: "/wing_tip_cloud.webp" }, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-14kgoxz">At First Landings Aviation Pilot Center, we will teach you to perfect
        your instrument flying skills by flying in actual weather conditions, as
        well as what factors to consider when making a go/no-go decision. Our
        instructors have experience in almost all weather conditions and we
        encourage students to gain that experience with us before attempting it
        on their own voluntarily or involuntarily. We try to cater our training
        to each individual student. Depending on your schedule you may be
        interested in our self-paced training option or our accelerated
        immersion course.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
          }
        })}</div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
